import React from 'react';
import styles from './MetricsOverview.module.css';

export default function MetricsOverview({ metrics }) {
    const { totalScans, uniqueUsers, topQR, scanGrowth, uniqueUsersGrowth, periodDays } = metrics;

    const formatNumber = (num) => {
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        } else if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        }
        return num.toString();
    };

    const getGrowthColor = (growth) => {
        if (growth > 0) return styles.positive;
        if (growth < 0) return styles.negative;
        return styles.neutral;
    };

    const getGrowthIcon = (growth) => {
        if (growth > 0) {
            return <i className="fa-solid fa-arrow-trend-up"></i>;
        } else if (growth < 0) {
            return <i className="fa-solid fa-arrow-trend-down"></i>;
        }
        return <i className="fa-solid fa-minus"></i>;
    };

    const metricCards = [
        {
            title: 'Total Scans',
            value: formatNumber(totalScans),
            icon: <i className="fa-regular fa-qrcode"></i>,
            growth: scanGrowth,
            description: 'QR code scans this period'
        },
        {
            title: 'Unique Users',
            value: formatNumber(uniqueUsers),
            icon: <i className="fa-solid fa-users"></i>,
            growth: uniqueUsersGrowth,
            description: 'Unique IP addresses'
        },
        {
            title: 'Top QR Code',
            value: topQR ? topQR.scans : '0',
            subtitle: topQR ? topQR.nickname.substring(0, 30) + (topQR.nickname.length > 30 ? '...' : '') : 'No data',
            icon: <i className="fa-solid fa-star"></i>,
            growth: null,
            description: 'Most scanned QR code'
        },
        {
            title: 'Avg. Scans/Day',
            value: totalScans > 0 && periodDays > 0 ? Math.round(totalScans / periodDays).toString() : '0',
            icon: <i className="fa-solid fa-chart-line"></i>,
            growth: null,
            description: 'Based on current period'
        }
    ];

    return (
        <div className={styles.container}>
            <div className={styles.grid}>
                {metricCards.map((card, index) => (
                    <div key={index} className={styles.card}>
                        <div className={styles.cardHeader}>
                            <div className={styles.iconContainer}>
                                {card.icon}
                            </div>
                            <div className={styles.cardTitle}>
                                {card.title}
                            </div>
                        </div>
                        
                        <div className={styles.cardBody}>
                            <div className={styles.value}>
                                {card.value}
                            </div>
                            
                            {card.subtitle && (
                                <div className={styles.subtitle}>
                                    {card.subtitle}
                                </div>
                            )}
                            
                            <div className={styles.description}>
                                {card.description}
                            </div>
                            
                            {card.growth !== null && card.growth !== undefined && (
                                <div className={`${styles.growth} ${getGrowthColor(card.growth)}`}>
                                    <span className={styles.growthIcon}>
                                        {getGrowthIcon(card.growth)}
                                    </span>
                                    <span className={styles.growthText}>
                                        {card.growth > 0 ? '+' : ''}{card.growth}%
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
} 